import { useDispatch, useSelector } from 'react-redux';
import { useCallback } from 'react';
import { IRootState } from '@state/reducers/Reducers';
import { CapturedImage } from '@ecosystem/newron-design-system/build/export-utils/captureImage';
import { clearExportImages, setExportImage } from '@state/feature/export-chart-images/ExportImagesSlice';

export const useExportImages = (pageType: number) => {
  const dispatch = useDispatch();

  const exportImages = useSelector((state: IRootState) => state.exportImages[pageType] ?? {});

  const handleExportImage = useCallback(
    (newImage: CapturedImage, imageKey: string) => {
      dispatch(setExportImage({ pageType, imageKey, newImage }));
    },
    [dispatch, pageType],
  );

  const clearExportImage = useCallback(() => {
    dispatch(clearExportImages(pageType));
  }, [dispatch, pageType]);

  return {
    exportImages,
    handleExportImage,
    clearExportImage,
  };
};
